import color from 'css-color-function'
import formula from './formula.json'
import compareColorCards from './compare-color-cards.json'
import { stylePatch } from './stylePatch'

/**
 * @description 处理获取颜色
 * @param style 检索样式表
 * @param className 检索类名
 * @param propertyName 检索属性名
 * */
export function handleGetColor (style, className, propertyName) {
  // 构建匹配 className 及其伪类状态的正则表达式
  const escapedClassName = className.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // 转义正则中的特殊字符
  const regexPattern = new RegExp(`\\.${escapedClassName}(?:\\s*\\{[^}]*\\b${propertyName}\\s*:\\s*([^;]+)?)?`, 'i')
  regexPattern.lastIndex = 0
  // 使用正则表达式匹配
  let result = regexPattern.exec(style)
  if (result && result[1]) {
    return result[1]
  }
  return null
}

/**
 * @description 处理颜色
 * @param colorKey 颜色key
 * @param primaryColor 颜色值
 * */
export function handleGenerateColors (colorKey, primaryColor) {
  let colors = {}
  Object.keys(formula).forEach(key => {
    const value = formula[key].replace(/primary/g, primaryColor)
    colors[`${colorKey}-${key}`] = rgbToHex(color.convert(value))
  })
  return colors
}

/**
 * @description 判断是否是颜色
 * @param color 颜色
 * */
export function isValidColor (color) {
  const hexColorRegex = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/
  const rgbColorRegex = /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/
  if (hexColorRegex.test(color)) {
    return true
  } else {
    return rgbColorRegex.test(color)
  }
}

/**
 * @description rgb颜色转成16进制
 * */
export function rgbToHex (rgb) {
  // 使用正则表达式匹配 rgb 中的数字
  const matches = rgb.match(/\d+/g)

  if (matches && matches.length === 3) {
    // 将匹配到的数字分别转换为十六进制，并拼接为最终的颜色值
    const hexColor = '#' + matches.map(component => {
      const hex = parseInt(component).toString(16)
      return hex.length === 1 ? '0' + hex : hex
    }).join('')

    return hexColor.toUpperCase() // 可选：将结果转为大写字母形式
  } else {
    // 处理不合法的输入
    return null
  }
}

/**
 * @description 获取样式
 * */
export function extractStyles (inputString, targetSelector, propertyName = null) {
  const pattern = new RegExp(`${targetSelector}\\s*\\{([^}]+)\\}`)
  const match = inputString.match(pattern)
  if (match && match[1] && propertyName) {
    return extractPropertyValueFromString(match[1], propertyName)
  } else if (match && match[1] && !propertyName) {
    return match[1]
  }
  return null
}

export function extractPropertyValueFromString (inputString, propertyName) {
  const propertyPattern = new RegExp(`${propertyName}\\s*:\\s*([^;]+)`)
  const propertyMatch = inputString.match(propertyPattern)
  return propertyMatch ? propertyMatch[1].trim() : null
}

/**
 * @description 处理颜色卡片模板
 * */
export function handleCompareColorCards (style, objKey) {
  let handleKey = {
    'shade-1': 'shade-1',
    'light-1': 'shade-1',
    'light-2': 'light-2',
    'light-3': 'light-5',
    'light-4': 'light-6',
    'light-5': 'light-8',
    'light-6': 'light-8',
    'light-9': 'light-9'
  }
  Object.keys(objKey).forEach(key => {
    let toLowerCaseKey = key.toLowerCase()
    let colorKey = compareColorCards[toLowerCaseKey]
    const newColor = handleGenerateColors(toLowerCaseKey, objKey[key])
    Object.keys(colorKey).forEach(colorItemKey => {
      if (colorKey[colorItemKey] && colorKey[colorItemKey].className && colorKey[colorItemKey].propertyName) {
        let oldColor = extractStyles(style, colorKey[colorItemKey].className, colorKey[colorItemKey].propertyName)
        let newKey = handleKey[colorItemKey.replace(`${toLowerCaseKey}-`, '')]
        style = style.replace(new RegExp(oldColor, 'g'), newColor[`${toLowerCaseKey}-${newKey}`])
      }
    })
  })
  return style
}

/**
 * @description 更新样式表
 * */
export function updateStyle (text) {
  let count = sessionStorage.getItem('count')
  let cssText = stylePatch(text)
  if (count && Number(count) === document.styleSheets.length) {
    document.head.lastChild.innerText = cssText
  } else {
    sessionStorage.setItem('count', (document.styleSheets.length + 1).toString())
    const style = document.createElement('style')
    style.innerText = cssText
    document.head.appendChild(style)
  }
}

/**
 * @description 获取当前主题色
 * */
export function getThemeColor (style) {
  const primary = /\.el-button--primary[^}]*\{[^}]*\bbackground-color\s*:\s*([^;]+)/g
  const success = /\.el-button--success[^}]*\{[^}]*\bbackground-color\s*:\s*([^;]+)/g
  const warning = /\.el-button--warning[^}]*\{[^}]*\bbackground-color\s*:\s*([^;]+)/g
  const danger = /\.el-button--danger[^}]*\{[^}]*\bbackground-color\s*:\s*([^;]+)/g
  const info = /\.el-button--info[^}]*\{[^}]*\bbackground-color\s*:\s*([^;]+)/g
  let match1 = primary.exec(style)
  let match2 = success.exec(style)
  let match3 = warning.exec(style)
  let match4 = danger.exec(style)
  let match5 = info.exec(style)
  const obj = {}
  if (match1 && match1.length) {
    obj.primary = match1[1]
  }
  if (match2 && match2.length) {
    obj.success = match2[1]
  }
  if (match3 && match3.length) {
    obj.warning = match3[1]
  }
  if (match4 && match4.length) {
    obj.danger = match4[1]
  }
  if (match5 && match5.length) {
    obj.info = match5[1]
  }
  return obj
}



// WEBPACK FOOTER //
// ./src/utils/common.js